import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FormControl, UntypedFormGroup, Validators, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { Location } from '@angular/common';

import { PeripheralInfoPluginService } from './peripheralinfo-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

import * as _ from 'lodash';

@Component({
    selector: 'peripheralinfo-edit',
    templateUrl: './peripheralinfo-edit.component.html',
    standalone: false
})
export class PeripheralInfoEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  editForm: UntypedFormGroup;
  public currentItem: any;
  public peripheralInfos: any;
  public processing = false;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: PeripheralInfoPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updatePeripheralInfo(this.inspectionId, this.pluginId, model.peripheralInfos).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.peripheralInfos = this.plugin.config.PeripheralInfos != null ? this.plugin.config.PeripheralInfos : [];
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  remove(i: number) {
    const control = <UntypedFormArray>this.editForm.controls['peripheralInfos'];
    control.removeAt(i);
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['peripheralInfos'];
    control.push(this.initPeripheralInfo());
  }

  initPeripheralInfo(el?: any) {
    return this.fb.group({
      Name: [el ? el.Name : ''],
      Number: [el ? el.Number : '']
    });
  }

  initForm() {
    this.editForm = this.fb.group({
      peripheralInfos: this.fb.array([])
    });
    const control = <UntypedFormArray>this.editForm.controls['peripheralInfos'];
    _.forEach(this.peripheralInfos, (el) => {
      control.push(this.initPeripheralInfo(el));
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['peripheralInfos'];
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
